// extracted by mini-css-extract-plugin
export default {"advertDetailHeader":"c-m_fe"};